import { detectIE } from 'lib/helpers';

if (detectIE() !== false && !document.body.classList.contains('IE')) {
  document.body.classList.add('IE');
}
